const { default: CommonServices } = require("./common/common");

class MagzineManagementService extends CommonServices {
  constructor() {
    super("/magazine");
  }
}

const magzineManagementService = new MagzineManagementService();
export default magzineManagementService;
